import { ImageGenParams } from './ImageGenApi';

// The image backend maps `seed` onto the provider's `generation_config.seed`,
// which is a signed 32-bit int. A caller passing a uint32 (or anything out of
// range) is rejected by the provider with an opaque error, so fail fast here
// with a clear, actionable message instead of surfacing a server 500.
export const MAX_IMAGE_GEN_SEED = 0x7fffffff; // 2147483647

export function assertValidImageGenSeed(seed: ImageGenParams['seed']): void {
  if (seed === undefined) return;
  if (!Number.isInteger(seed) || seed < 0 || seed > MAX_IMAGE_GEN_SEED) {
    throw new Error(
      `imageGen: seed must be an integer between 0 and ${MAX_IMAGE_GEN_SEED} (got ${seed})`,
    );
  }
}
